var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-10 d-flex-column container p-1"},[_vm._t("notifications"),_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }